import React from 'react'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { dataSlice } from '../../../redux/slices'
import {
  DataSearchResponseItem,
  DataSearchResponseItemVersion
} from '../../../services/endpoints/data'
import { getFileSize } from '../../../utils/helpers'
interface ResultsGridDataColProps {
  key: DataSearchResponseItem
}

export const ResultsGridDataCol: React.FC<ResultsGridDataColProps> = ({
  key
}) => {
  return (
    <div className="dataset-display">
      {key.versions.map((i) => (
        <_Row key={`ResultGridDataColRow-${i.id}`} data={i} />
      ))}
    </div>
  )
}

export const _Row: React.FC<{ data: DataSearchResponseItemVersion }> = ({
  data
}) => {
  const { selected, type, size } = useAppSelector(
    (state) => state.data.versions[data.id]
  )
  const dispatch = useDispatch()

  return (
    <button
      className={`data-type-button ${selected ? 'active' : ''}`}
      onClick={() => dispatch(dataSlice.actions.toggleVersion(data.id))}
    >
      <div className="data-type-extension">{type.toUpperCase()}</div>
      <div className="data-type-size">{getFileSize(size)}</div>
    </button>
  )
}
